import type { Box } from '../strangler'

// Ending-sequence progress counter 0..47 (pristine: script.js:2539 init,
// :2541+ bigFinish choreography, grayscale at :2575; render.js:280/:374/:480
// pan guards). timePlayedUp halts while it is non-zero. Future owner: engine
// ending state, with the grayscale as a ui effect (step 13).
export const bigFinishPoint: Box<number> = { value: 0 }
